import React from "react";
import Navbar from "../components/Navbar";
import Media from "react-media";
import { Helmet } from "react-helmet";
import "../pages/styles/home.css";
import {Link} from 'react-router-dom'
import "../components/styles/buttons.css";
import Map from "../components/Google-maps";
import Form from "../components/Form";
import Footer from "../components/Footer";
import { useTranslation , Trans} from 'react-i18next';

const Home = ()=> {
  const { t } = useTranslation();



  return (
    <React.Fragment>
      <Helmet>
        <title>{t('titleHome')}</title>
        <meta name="keywords" content="clinica,dental,santa ana,muelas, dientes, san jose, costa rica, dental care, teeth."/>
        <meta name="description" content="Especialistas en el cuidado de su sonrisa, estamos ubicados en Santa Ana, Costa Rica."/>
      </Helmet>
      <Navbar />
      <main className="mainContent">
        <header className="header-home">
          <div className="header-info">
            <h2>{t("homeTitle1")}</h2>
            <br />
            <h1>
              {t('homeTitle2')}
              <span>{t('homeTile2Span')}</span>
            </h1>
            <h1><Trans>{t('homeTitle3')}</Trans></h1>
            <hr />
            <p  className="heroText">
               <Trans>
               {t('homeParaf')}
               </Trans> 
            </p>
            <br />
            <Media query={{ maxWidth: 839 }}>
              <Link className="buttonGhost" to="/contacto">
                {t('homeButton')}
              </Link>
            </Media>
            <Media query={{ minWidth: 839 }}>
              <Link className="buttonGreen" to="/contacto">
                {t('homeButton')}
              </Link>
            </Media>
          </div>
          <div className="header-img">
          </div>
        </header>
        <section className="treamentsConteiner conteiner">
          <h2>
            <Trans>{t('homeSection1Title')}</Trans>  
          </h2>
          <p>
              {t('homeSection1Paraf')}
          </p>
          <hr />
          <div className="boxConteiner">
            <div className="box">
              <img src={require("./media/dental-care.svg")} alt="" />
              <h4> {t('homeSection1Endo')}</h4>
              <hr />
              <p className="textContein">
                {t('homeSection1EndoParaf')}
              </p>
              <br/>
              <Link className="buttonGreen" to="/endodoncia">
                {t('seeMoreButton')}
              </Link>
            </div>
            <div className="box">
              <img src={require("../assents-img/stetic.svg")} alt="" />
              <h4>{t('homeSection1Cosm')}</h4>
              <hr />
              <p className="textContein">
              {t('homeSection1CosmParaf')}
              </p>
              <Link to='/estética-dental' className="buttonGreen" >
                {t('seeMoreButton')}
              </Link>
            </div>
            <div className="box">
              <img src={require("../assents-img/braces.svg")} alt="" />
              <h4>{t('homeSection1Orto')}</h4>
              <hr />
              <p className="textContein">
                {t('homeSection1OrtoParaf')}
              </p>
              <br/>
              <Link className="buttonGreen" to="/ortodoncia">
                {t('seeMoreButton')}
              </Link>
            </div>
          </div>
          <Link className="buttonGhost2" to="/tratamientos">
              {t('homeSection1Link')}
          </Link>
        </section>
        <section className="aboutConteiner conteiner">
          <h2>{t('homeSection2Title')}</h2>
          <hr />
          <img src={require("./media/header.jpg")} alt="" />
          <div className="boxText">
            <p>
              <Trans>{t('homeSection2Paraf')}</Trans>
            </p>
          </div>
        </section>
        <section className="sectionMap">
          <div className="map conteiner">
            <div className="textMap">
              <h2>{t('homeSection3Title')}</h2>
              <hr />
              <p>
                  <Trans>
                  {t('homeSection3paraf')}
                  </Trans>
              </p>
            </div>
            <div className="GoogleMaps">
              <Map />
            </div>
          </div>
        </section>
        <section className="ourTeam conteiner">
          <h2>{t('homeSection4Title')}</h2>
          <div className="doctor1">
            <img
              className="doctorImg"
              src={require("./media/doctor1.svg")}
              alt=""
            />
            <div className="doctorInfo">
              <h4>Dr. Oscar Soto Chacon</h4>
              <hr />
              <p>
                  <Trans>
                  {t('homeSection4Description1')}
                  </Trans>
              </p>
            </div>
          </div>
          <Media query={{ maxWidth: 666 }}>
            <div className="doctor2">
              <img
                className="doctorImg"
                src={require("./media/doctor2.svg")}
                alt=""
              />
              <div className="doctorInfo">
                <h4>Dra. Ericka Madrigal Romero</h4>
                <hr />
                <p>
                  <Trans>
                  {t('homeSection4Description2')}
                  </Trans>
                </p>
              </div>
            </div>
          </Media>
          <Media query={{ minWidth: 667 }}>
            <div className="doctor2">
              <div className="doctorInfo">
                <h4>Dra. Ericka Madrigal Romero</h4>
                <hr />
                <p>
                <Trans>
                  {t('homeSection4Description2')}
                  </Trans>
                </p>
              </div>
              <img
                className="doctorImg"
                src={require("./media/doctor2.svg")}
                alt=""
              />
            </div>
          </Media>
          <Link className="buttonGhost2" to='/nosotros'>
            {t('homeSection4MeetTeam')}
          </Link>
        </section>
        <br />
        <br />
        <Form />
        <Footer />
      </main>
    </React.Fragment>
  );
}

export default Home;
